import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../i18n';

const initialState = {
  isOpen: false,
  status: 'idle', // 'idle' | 'processing' | 'failed' | 'success'
  purchaseId: null,
  item: null, // { id, label, img, description }
  tonAmount: null,
  usdAmount: null,
  error: null,
  transactionHash: null,
  walletAddress: null,
};

const tonPaymentSlice = createSlice({
  name: 'tonPayment',
  initialState,
  reducers: {
    startTonPayment: (state, action) => {
      const {
        purchaseId,
        item,
        tonAmount,
        usdAmount,
        transactionHash,
        walletAddress,
      } = action.payload;

      state.isOpen = true;
      state.status = 'processing';
      state.purchaseId = purchaseId;
      state.item = item;
      state.tonAmount = tonAmount ?? null;
      state.usdAmount = usdAmount ?? null;
      state.error = null;
      state.transactionHash = transactionHash ?? null;
      state.walletAddress = walletAddress ?? null;
    },
    setTonPaymentFailed: (state, action) => {
      const { purchaseId, error } = action.payload ?? {};

      if (purchaseId && state.purchaseId && purchaseId !== state.purchaseId) {
        return;
      }

      if (!state.isOpen) {
        state.isOpen = true;
      }

      state.status = 'failed';
      state.error =
        error ||
        i18n.t('payment.verify_failed_later', 'The DATUM system couldn’t verify your transaction. Please try again later.');
    },
    setTonPaymentSuccess: (state, action) => {
      const { purchaseId } = action.payload ?? {};

      if (purchaseId && state.purchaseId && purchaseId !== state.purchaseId) {
        return;
      }

      return initialState;
    },
    clearTonPayment: () => initialState,
  },
});

export const {
  startTonPayment,
  setTonPaymentFailed,
  setTonPaymentSuccess,
  clearTonPayment,
} = tonPaymentSlice.actions;

export default tonPaymentSlice.reducer;

